<template>
  <div class="userSetting__container">
    <h1 class="userSetting__title">個人設定</h1>

    <div class="ui top attached tabular menu">
      <a class="item active" data-tab="info">会員情報</a>
      <a class="item" data-tab="password">パスワード</a>
      <!--a class="item" data-tab="sns">SNS連携</a-->
    </div>

    <div class="ui bottom attached tab segment active" data-tab="info">
      <edit-profile></edit-profile>
      <div class="userSetting__unsubscribeContainer">
        <h2 class="userSetting__sectionTitle">退会をご希望される場合</h2>
        <button class="ui button negative" v-show="!leaveNow" @click="leaveNow = true">グルメプラスを退会する</button>
        <div v-if="leaveNow" class="userSetting__unsubscribeConfirm">
          <div class="ui warning message">
            <div class="header">
              コンシェルジュとのチャットなどが全て削除されます
            </div>
            この操作は取り消せません。本当に退会しますか？
          </div>
          <button class="ui button" @click="leaveNow = false">退会をキャンセル</button>
          <button class="ui button negative" :class="{'loading disabled': leaveForm.waiting}" @click="leave">退会する</button>
        </div>
      </div>
    </div>

    <div class="ui bottom attached tab segment" data-tab="password">
      <change-password></change-password>
    </div>

    <div v-if="false" class="ui bottom attached tab segment" data-tab="sns">
      <p>SNSと連携すると、ログインを簡単に行うことができます</p>

      <div class="ui cards">
        <div class="card">
          <div class="content">
            <div class="header"><i class="inverted facebook icon" style="color: #3b5998;"></i> Facebook</div>
          </div>
          <div class="ui bottom attached button primary">
            <i class="add icon"></i>
            連携する
          </div>
        </div>
      </div>

      <div class="ui cards">
        <div class="card">
          <div class="content">
            <div class="header"><i class="inverted facebook icon" style="color: #3b5998;"></i> Facebook</div>
            <div class="description">
              <a href="">{user name}で連携中</a>
            </div>
          </div>
          <div class="ui bottom attached button">
            <i class="close icon"></i>
            連携を解除する
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import EditProfileForm from './components/editProfile.vue';
import ChangePasswordForm from './components/changePassword.vue';

export default {
    components: {
        'edit-profile': EditProfileForm,
        'change-password': ChangePasswordForm,
    },
    data: function() {
        return {
            leaveForm: this.createForm(),
            leaveNow: false
        }
    },
    mounted: function() {
        $('.menu .item').tab({
            history: true,
            historyType: 'hash'
        });
    },
    methods: {
        leave: function() {
            this.leaveForm.post('/api/leave', function() {
                window.location.href = '/';
            });
        }
    }
};
</script>
